import { memo } from 'react';
import { FilePrimitive } from './primitive';
import { useI18n } from '@/providers/i18n';
import { areNodePropsEqual } from '../are-node-props-equal';

export type FileNodeProps = {
  type: string;
  data: {
    content?: {
      url: string;
      type: string;
      name: string;
    };
    text?: string;
    fileName?: string;
    updatedAt?: string;
    scale?: number;
  };
  id: string;
};

export const FileNode = memo((props: FileNodeProps) => {
  const { t } = useI18n();
  return <FilePrimitive {...props} title={t('File Node')} />;
}, areNodePropsEqual);
FileNode.displayName = 'FileNode';
